

// import React, { useEffect, useState, useRef } from 'react';
// import api from '../../services/api';
// import { useTheme as useCustomTheme } from '../../context/ThemeContext';
// import {
//   BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
//   ResponsiveContainer, PieChart, Pie, Cell, Legend
// } from 'recharts';

// /* ─── Font injection ─────────────────────────────────────────────── */
// if (typeof document !== 'undefined' && !document.getElementById('al-fonts')) {
//   const link = document.createElement('link');
//   link.id = 'al-fonts';
//   link.rel = 'stylesheet';
//   link.href =
//     'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap';
//   document.head.appendChild(link);
// }

// /* ─── Design tokens ─────────────────────────────────────────────── */
// const T = {
//   ink: '#0F172A',
//   ink2: '#1E293B',
//   slate: '#64748B',
//   muted: '#94A3B8',
//   faint: '#CBD5E1',
//   bg: '#F8FAFC',
//   surface: '#FFFFFF',
//   surface2: '#F8FAFC',
//   bdr: '#E2E8F0',
//   bdr2: '#CBD5E1',
//   red: '#DC2626', redBg: '#FEF2F2', redBdr: '#FECACA',
//   amb: '#B45309', ambBg: '#FFFBEB', ambBdr: '#FDE68A',
//   grn: '#15803D', grnBg: '#F0FDF4', grnBdr: '#BBF7D0',
//   blue: '#3B82F6', blueBg: '#EFF6FF', blueBdr: '#BFDBFE',
//   indigo: '#1E40AF',
//   purple: '#8B5CF6', purpleBg: '#F5F3FF', purpleBdr: '#DDD6FE',
//   cyan: '#06B6D4', cyanBg: '#ECFEFF', cyanBdr: '#CFFAFE',
//   orange: '#F97316', orangeBg: '#FFF7ED', orangeBdr: '#FED7AA',
// };

// const sans = "'Inter', system-ui, sans-serif";
// const mono = "'JetBrains Mono', monospace";

// /* ─── Avatar helpers ─────────────────────────────────────────────── */
// const getInitials = (name: string): string => {
//   if (!name || name === 'System') return 'S';
//   const parts = name.split(' ');
//   if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
//   return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
// };

// const getAvatarColor = (name: string): string => {
//   const colors = [
//     '#DC2626', '#EA580C', '#D97706', '#16A34A', '#3B82F6', '#8B5CF6',
//     '#EC4899', '#06B6D4', '#84CC16', '#F97316', '#6366F1', '#14B8A6'
//   ];
//   let hash = 0;
//   for (let i = 0; i < name.length; i++) {
//     hash = ((hash << 5) - hash) + name.charCodeAt(i);
//     hash |= 0;
//   }
//   return colors[Math.abs(hash) % colors.length];
// };

// /* ─── Types ──────────────────────────────────────────────────────── */
// interface AuditEvent {
//   id: number;
//   timestamp: string;
//   user_name: string;
//   user_role?: string;
//   user_id?: string;
//   action: string;
//   resource: string;
//   resource_type: string;
//   ip_address: string;
//   status: string;
//   details?: string;
// }

// interface AuditStats {
//   total_events: number;
//   total_events_change: number;
//   user_activities: number;
//   user_activities_change: number;
//   data_changes: number;
//   data_changes_change: number;
//   security_events: number;
//   security_events_change: number;
//   events_over_time: Array<{ date: string; count: number }>;
//   events_by_type: Array<{ type: string; count: number }>;
//   top_users: Array<{ user: string; count: number }>;
//   recent_security_events: Array<{ description: string; user?: string; timestamp?: string; severity?: string }>;
// }

// interface FilterState {
//   startDate: string;
//   endDate: string;
//   user: string;
//   action: string;
//   resourceType: string;
//   status: string;
//   search: string;
// }

// const CHART_COLORS = ['#3B82F6', '#DC2626', '#16A34A', '#8B5CF6', '#B45309', '#06B6D4'];

// /* ─── Resource Type Badge ────────────────────────────────────────── */
// const ResourceTypeBadge: React.FC<{ type: string; isDark?: boolean }> = ({ type, isDark }) => {
//   const typeMap: Record<string, { bg: string; color: string; border: string; darkBg: string }> = {
//     Vendor:    { bg: '#EFF6FF', color: '#3B82F6', border: '#BFDBFE', darkBg: '#0a1628' },
//     Scan:      { bg: '#F5F3FF', color: '#8B5CF6', border: '#DDD6FE', darkBg: '#150a1f' },
//     Indicator: { bg: '#FFFBEB', color: '#B45309', border: '#FDE68A', darkBg: '#1a1400' },
//     User:      { bg: '#ECFEFF', color: '#06B6D4', border: '#CFFAFE', darkBg: '#0a1a1a' },
//     Report:    { bg: '#F0FDF4', color: '#15803D', border: '#BBF7D0', darkBg: '#0a1a0a' },
//     Auth:      { bg: '#FFF7ED', color: '#F97316', border: '#FED7AA', darkBg: '#1a0f00' },
//   };
//   const style = typeMap[type] || { bg: '#F8FAFC', color: '#64748B', border: '#E2E8F0', darkBg: '#1a1a1a' };
//   const bg = isDark ? style.darkBg : style.bg;
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center',
//       padding: '2px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 600,
//       background: bg, color: style.color, border: `1px solid ${isDark ? style.color + '40' : style.border}`,
//     }}>
//       {type}
//     </span>
//   );
// };

// /* ─── Status Badge ───────────────────────────────────────────────── */
// const StatusBadge: React.FC<{ status: string; isDark?: boolean }> = ({ status, isDark }) => {
//   const isSuccess = status === 'Success';
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center', gap: '4px',
//       padding: '3px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: 600,
//       background: isSuccess ? (isDark ? '#0a1a0a' : '#F0FDF4') : (isDark ? '#1a0a0a' : '#FEF2F2'),
//       color: isSuccess ? '#15803D' : '#DC2626',
//       border: `1px solid ${isSuccess ? (isDark ? '#15803D40' : '#BBF7D0') : (isDark ? '#DC262640' : '#FECACA')}`,
//     }}>
//       <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: isSuccess ? '#15803D' : '#DC2626' }} />
//       {status}
//     </span>
//   );
// };

// /* ─── Metric Card ────────────────────────────────────────────────── */
// const MetricCard: React.FC<{
//   title: string;
//   value: number;
//   change: number;
//   icon: React.ReactNode;
//   iconBg: string;
//   darkIconBg: string;
//   isDark?: boolean;
// }> = ({ title, value, change, icon, iconBg, darkIconBg, isDark }) => {
//   const isPositive = change >= 0;
//   const bg = isDark ? darkIconBg : iconBg;
//   return (
//     <div style={{
//       background: isDark ? '#0d0d0d' : '#FFFFFF',
//       border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//       borderRadius: '12px',
//       padding: '20px', display: 'flex', alignItems: 'flex-start', gap: '16px',
//     }}>
//       <div style={{
//         width: '44px', height: '44px', borderRadius: '10px', background: bg,
//         display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
//       }}>
//         {icon}
//       </div>
//       <div style={{ flex: 1 }}>
//         <div style={{ fontSize: '12px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B', marginBottom: '6px' }}>
//           {title}
//         </div>
//         <div style={{ fontSize: '28px', fontWeight: 700, color: isDark ? '#e2e8f0' : '#0F172A', lineHeight: 1, marginBottom: '6px' }}>
//           {value.toLocaleString()}
//         </div>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//           <span style={{ fontSize: '12px', fontWeight: 600, color: isPositive ? '#15803D' : '#DC2626' }}>
//             {isPositive ? '↑' : '↓'} {Math.abs(change)}%
//           </span>
//           <span style={{ fontSize: '11px', color: isDark ? '#94a3b8' : '#64748B' }}>vs previous period</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─── Detail Modal Component ─────────────────────────────────────── */
// interface DetailModalProps {
//   open: boolean;
//   onClose: () => void;
//   log: AuditEvent | null;
//   isDark?: boolean;
// }

// const DetailModal: React.FC<DetailModalProps> = ({ open, onClose, log, isDark }) => {
//   if (!open || !log) return null;

//   const { date, time } = (() => {
//     const d = new Date(log.timestamp);
//     return {
//       date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
//       time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
//     };
//   })();

//   const colors = {
//     bg: isDark ? '#0d0d0d' : '#FFFFFF',
//     border: isDark ? '#1f1f1f' : '#E2E8F0',
//     text: isDark ? '#e2e8f0' : '#0F172A',
//     muted: isDark ? '#94a3b8' : '#64748B',
//     surface2: isDark ? '#1a1a1a' : '#F8FAFC',
//   };

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: 'fixed', inset: 0, zIndex: 2000,
//         background: 'rgba(0, 0, 0, 0.5)',
//         backdropFilter: 'blur(2px)',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         padding: '24px',
//       }}
//     >
//       <div
//         onClick={e => e.stopPropagation()}
//         style={{
//           width: '100%', maxWidth: '560px',
//           background: colors.bg, borderRadius: '16px',
//           border: `1px solid ${colors.border}`, overflow: 'hidden',
//           boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
//         }}
//       >
//         {/* Header */}
//         <div style={{
//           padding: '18px 20px', borderBottom: `1px solid ${colors.border}`,
//           background: colors.bg, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//         }}>
//           <div>
//             <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: colors.text }}>Event Details</h3>
//             <p style={{ margin: '2px 0 0', fontSize: '11px', color: colors.muted }}>Log ID: {log.id}</p>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               width: '28px', height: '28px', borderRadius: '6px',
//               border: `1px solid ${colors.border}`, background: colors.bg,
//               cursor: 'pointer', fontSize: '16px', color: colors.muted,
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//             }}
//           >
//             ×
//           </button>
//         </div>

//         {/* Body */}
//         <div style={{ padding: '20px' }}>
//           <div style={{ display: 'grid', gap: '14px' }}>
//             <DetailRow label="Action" value={log.action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} colors={colors} />
//             <DetailRow label="User" value={log.user_name || 'System'} colors={colors} />
//             <DetailRow label="Resource" value={log.resource || '—'} colors={colors} />
//             <DetailRow label="Resource Type" value={log.resource_type || '—'} colors={colors} />
//             <DetailRow label="IP Address" value={log.ip_address || '—'} colors={colors} />
//             <DetailRow label="Status" value={log.status} colors={colors} />
//             <DetailRow label="Date & Time" value={`${date} at ${time}`} colors={colors} />
//             {log.details && (
//               <div>
//                 <div style={{ fontSize: '11px', fontWeight: 600, color: colors.muted, marginBottom: '6px', textTransform: 'uppercase' }}>
//                   Details
//                 </div>
//                 <div style={{
//                   padding: '10px 12px', background: colors.surface2, borderRadius: '8px',
//                   fontSize: '12px', color: colors.text, border: `1px solid ${colors.border}`,
//                 }}>
//                   {log.details}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Footer */}
//         <div style={{ padding: '14px 20px', borderTop: `1px solid ${colors.border}`, display: 'flex', justifyContent: 'flex-end' }}>
//           <button
//             onClick={onClose}
//             style={{
//               padding: '6px 16px', borderRadius: '6px', fontSize: '12px', fontWeight: 500,
//               background: isDark ? '#3B82F6' : '#0F172A', border: 'none', color: '#fff', cursor: 'pointer',
//             }}
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DetailRow: React.FC<{ label: string; value: string; colors: any }> = ({ label, value, colors }) => (
//   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
//     <div style={{ width: '100px', fontSize: '11px', fontWeight: 600, color: colors.muted, textTransform: 'uppercase', flexShrink: 0 }}>
//       {label}
//     </div>
//     <div style={{ fontSize: '12px', color: colors.text, wordBreak: 'break-word', flex: 1 }}>
//       {value}
//     </div>
//   </div>
// );

// /* ─── Action icon ────────────────────────────────────────────────── */
// const ActionIcon: React.FC<{ action: string; isDark?: boolean }> = ({ action, isDark }) => {
//   const a = action.toLowerCase();
//   let bg = isDark ? '#0a1628' : '#EFF6FF', color = '#3B82F6', symbol = '📋';
//   if (a.includes('update') || a.includes('modified') || a.includes('changed')) { bg = isDark ? '#1a1400' : '#FFFBEB'; color = '#B45309'; symbol = '✏️'; }
//   else if (a.includes('create') || a.includes('add') || a.includes('new')) { bg = isDark ? '#0a1a0a' : '#F0FDF4'; color = '#15803D'; symbol = '➕'; }
//   else if (a.includes('delete') || a.includes('remove')) { bg = isDark ? '#1a0a0a' : '#FEF2F2'; color = '#DC2626'; symbol = '🗑️'; }
//   else if (a.includes('login') || a.includes('auth')) { bg = isDark ? '#150a1f' : '#F5F3FF'; color = '#8B5CF6'; symbol = '🔐'; }
//   else if (a.includes('scan')) { bg = isDark ? '#0a1a1a' : '#ECFEFF'; color = '#06B6D4'; symbol = '🔍'; }
//   else if (a.includes('download') || a.includes('export')) { bg = isDark ? '#0a1a0a' : '#F0FDF4'; color = '#15803D'; symbol = '⬇️'; }
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
//       width: '28px', height: '28px', borderRadius: '6px', background: bg,
//       fontSize: '13px', flexShrink: 0,
//     }}>
//       {symbol}
//     </span>
//   );
// };

// /* ─── Custom Tooltip for charts ──────────────────────────────────── */
// const ChartTooltip: React.FC<any> = ({ active, payload, label, isDark }) => {
//   if (!active || !payload?.length) return null;
//   const colors = {
//     bg: isDark ? '#0d0d0d' : '#FFFFFF',
//     border: isDark ? '#1f1f1f' : '#E2E8F0',
//     text: isDark ? '#e2e8f0' : '#0F172A',
//   };
//   return (
//     <div style={{
//       background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: '8px',
//       padding: '8px 12px', fontSize: '12px', color: colors.text, boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
//     }}>
//       <div style={{ fontWeight: 600, marginBottom: '2px' }}>{label}</div>
//       {payload.map((p: any, i: number) => (
//         <div key={i} style={{ color: p.color }}>{p.value?.toLocaleString()}</div>
//       ))}
//     </div>
//   );
// };

// /* ─── Icons (inline SVG) ─────────────────────────────────────────── */
// const IconDoc = ({ color = '#6366F1' }) => (
//   <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
//     <rect x="4" y="2" width="16" height="20" rx="2" stroke={color} strokeWidth="2" fill="none"/>
//     <line x1="8" y1="8" x2="16" y2="8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
//     <line x1="8" y1="12" x2="16" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
//     <line x1="8" y1="16" x2="12" y2="16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );
// const IconUser = ({ color = '#3B82F6' }) => (
//   <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
//     <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2" fill="none"/>
//     <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none"/>
//   </svg>
// );
// const IconDb = ({ color = '#10B981' }) => (
//   <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
//     <ellipse cx="12" cy="6" rx="8" ry="3" stroke={color} strokeWidth="2" fill="none"/>
//     <path d="M4 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6" stroke={color} strokeWidth="2" fill="none"/>
//     <path d="M4 12v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" stroke={color} strokeWidth="2" fill="none"/>
//   </svg>
// );
// const IconShield = ({ color = '#EF4444' }) => (
//   <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
//     <path d="M12 3L4 6v6c0 5.25 3.5 10.15 8 11.5C16.5 22.15 20 17.25 20 12V6l-8-3z" stroke={color} strokeWidth="2" fill="none"/>
//     <path d="M9 12l2 2 4-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//   </svg>
// );
// const IconCalendar = ({ color = '#64748B' }) => (
//   <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
//     <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" fill="none"/>
//     <line x1="3" y1="10" x2="21" y2="10" stroke={color} strokeWidth="2"/>
//     <line x1="8" y1="2" x2="8" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
//     <line x1="16" y1="2" x2="16" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );
// const IconSearch = ({ color = '#94A3B8' }) => (
//   <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
//     <circle cx="11" cy="11" r="7" stroke={color} strokeWidth="2"/>
//     <line x1="16.5" y1="16.5" x2="21" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );
// const IconExport = () => (
//   <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
//     <path d="M12 3v12M8 11l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );
// const IconSettings = () => (
//   <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
//     <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
//     <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );
// const IconFilter = () => (
//   <svg width="13" height="13" fill="none" viewBox="0 0 24 24">
//     <path d="M3 6h18M7 12h10M11 18h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );
// const IconReset = () => (
//   <svg width="13" height="13" fill="none" viewBox="0 0 24 24">
//     <path d="M4 4v5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M4.07 13A8 8 0 1020 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );

// /* ─── Main Component ─────────────────────────────────────────────── */
// export default function AuditLogs() {
//   // ─── Theme Colors ──────────────────────────────────────────────────────────
//   const { mode } = useCustomTheme();
//   const isDark = mode === 'dark';

//   const themeColors = {
//     text: isDark ? '#e2e8f0' : '#0F172A',
//     muted: isDark ? '#94a3b8' : '#64748B',
//     background: isDark ? '#000000' : '#F8FAFC',
//     cardBg: isDark ? '#0d0d0d' : '#FFFFFF',
//     border: isDark ? '#1f1f1f' : '#E2E8F0',
//     hover: isDark ? '#141414' : '#F8FAFC',
//     paper: isDark ? '#0d0d0d' : '#FFFFFF',
//     inputBg: isDark ? '#0d0d0d' : '#FFFFFF',
//     chipBg: isDark ? '#1a1a1a' : '#F1F5F9',
//     surface: isDark ? '#0d0d0d' : '#FFFFFF',
//     surface2: isDark ? '#1a1a1a' : '#F8FAFC',
//   };

//   const [logs, setLogs] = useState<AuditEvent[]>([]);
//   const [stats, setStats] = useState<AuditStats | null>(null);
//   const [loading, setLoading] = useState(true);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [perPage, setPerPage] = useState(10);
//   const [selectedLog, setSelectedLog] = useState<AuditEvent | null>(null);
//   const [modalOpen, setModalOpen] = useState(false);

//   const [filters, setFilters] = useState<FilterState>({
//     startDate: '',
//     endDate: '',
//     user: '',
//     action: '',
//     resourceType: '',
//     status: '',
//     search: '',
//   });

//   const [users, setUsers] = useState<Array<{ id: string; name: string }>>([]);
//   const [actions, setActions] = useState<string[]>([]);
//   const [resourceTypes, setResourceTypes] = useState<string[]>([]);
//   const [dateRangeLabel, setDateRangeLabel] = useState('May 1, 2024 – May 31, 2024');
//   const [timeRange, setTimeRange] = useState('Last 7 Days');
//   const [showMoreFilters, setShowMoreFilters] = useState(false);

//   useEffect(() => {
//     fetchStats();
//     fetchLogs();
//     fetchFilterOptions();
//   }, [page, perPage, filters, timeRange]);

//   const fetchStats = async () => {
//     try {
//       const response = await api.get('/v1/audit/stats');
//       setStats(response.data);
//     } catch (error) {
//       console.error('Failed to fetch stats:', error);
//     }
//   };

//   const fetchLogs = async () => {
//     setLoading(true);
//     try {
//       const params: any = { page, per_page: perPage };
//       if (filters.startDate) params.start_date = filters.startDate;
//       if (filters.endDate) params.end_date = filters.endDate;
//       if (filters.user) params.user_id = filters.user;
//       if (filters.action) params.action = filters.action;
//       if (filters.resourceType) params.resource_type = filters.resourceType;
//       if (filters.search) params.search = filters.search;

//       const response = await api.get('/v1/audit/logs', { params });
//       setLogs(response.data.logs);
//       setTotal(response.data.total);
//     } catch (error) {
//       console.error('Failed to fetch logs:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchFilterOptions = async () => {
//     try {
//       const [usersRes, actionsRes, typesRes] = await Promise.all([
//         api.get('/v1/users'),
//         api.get('/v1/audit/actions'),
//         api.get('/v1/audit/resource-types'),
//       ]);
//       setUsers(usersRes.data);
//       setActions(actionsRes.data.actions || []);
//       setResourceTypes(typesRes.data.resource_types || []);
//     } catch (error) {
//       console.error('Failed to fetch filter options:', error);
//     }
//   };

//   const formatDate = (timestamp: string) => {
//     const d = new Date(timestamp);
//     return {
//       date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
//       time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
//     };
//   };

//   const totalPages = Math.ceil(total / perPage);

//   const handleReset = () => {
//     setFilters({ startDate: '', endDate: '', user: '', action: '', resourceType: '', status: '', search: '' });
//     setPage(1);
//   };

//   const handleRowClick = (log: AuditEvent) => {
//     setSelectedLog(log);
//     setModalOpen(true);
//   };

//   const selectStyle: React.CSSProperties = {
//     padding: '7px 10px',
//     border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//     borderRadius: '8px',
//     fontSize: '12px',
//     background: isDark ? '#0d0d0d' : '#FFFFFF',
//     fontFamily: sans,
//     cursor: 'pointer',
//     color: isDark ? '#e2e8f0' : '#0F172A',
//     outline: 'none',
//     minWidth: '120px',
//   };

//   /* ── Pie chart total ── */
//   const pieTotal = stats?.events_by_type?.reduce((s, e) => s + e.count, 0) || 0;

//   /* ── Custom Pie label ── */
//   const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) => {
//     if (percent < 0.05) return null;
//     const RADIAN = Math.PI / 180;
//     const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//     const x = cx + radius * Math.cos(-midAngle * RADIAN);
//     const y = cy + radius * Math.sin(-midAngle * RADIAN);
//     return (
//       <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize={10} fontWeight={600}>
//         {`${(percent * 100).toFixed(0)}%`}
//       </text>
//     );
//   };

//   return (
//     <div style={{ fontFamily: sans, background: isDark ? '#000000' : '#F8FAFC', minHeight: '100vh' }}>

//       {/* Detail Modal */}
//       <DetailModal open={modalOpen} onClose={() => setModalOpen(false)} log={selectedLog} isDark={isDark} />

//       {/* ── Header ── */}
//       <div style={{
//         padding: '16px 24px',
//         borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//         background: isDark ? '#0d0d0d' : '#FFFFFF',
//         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//       }}>
//         <div>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//             <h1 style={{ fontSize: '18px', fontWeight: 700, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
//               Audit Logs
//             </h1>
//             <span style={{
//               width: '16px', height: '16px', borderRadius: '50%', background: isDark ? '#1f1f1f' : '#E2E8F0',
//               display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
//               fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B', cursor: 'pointer', fontWeight: 600,
//             }}>i</span>
//           </div>
//           <p style={{ fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B', marginTop: '2px', margin: '2px 0 0' }}>
//             Track all user activities and system events across the platform.
//           </p>
//         </div>
//         <div style={{ display: 'flex', gap: '8px' }}>
//           <div style={{ position: 'relative', display: 'inline-flex' }}>
//             <button style={{
//               display: 'flex', alignItems: 'center', gap: '6px',
//               padding: '8px 14px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//               borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//               cursor: 'pointer', fontSize: '12px', fontWeight: 500,
//               color: isDark ? '#e2e8f0' : '#0F172A', fontFamily: sans,
//             }}>
//               <IconExport /> Export
//               <span style={{ marginLeft: '4px', color: isDark ? '#94a3b8' : '#64748B' }}>▾</span>
//             </button>
//           </div>
//           <button style={{
//             display: 'flex', alignItems: 'center', gap: '6px',
//             padding: '8px 14px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//             cursor: 'pointer', fontSize: '12px', fontWeight: 500,
//             color: isDark ? '#e2e8f0' : '#0F172A', fontFamily: sans,
//           }}>
//             <IconSettings /> Settings
//           </button>
//         </div>
//       </div>

//       {/* ── Metric Cards ── */}
//       <div style={{ padding: '20px 24px 16px', display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '16px' }}>
//         <MetricCard
//           title="Total Events" value={stats?.total_events || 0} change={stats?.total_events_change || 0}
//           icon={<IconDoc color={isDark ? '#8B5CF6' : '#6366F1'} />}
//           iconBg="#F5F3FF" darkIconBg="#150a1f" isDark={isDark}
//         />
//         <MetricCard
//           title="User Activities" value={stats?.user_activities || 0} change={stats?.user_activities_change || 0}
//           icon={<IconUser color={isDark ? '#3B82F6' : '#3B82F6'} />}
//           iconBg="#EFF6FF" darkIconBg="#0a1628" isDark={isDark}
//         />
//         <MetricCard
//           title="Data Changes" value={stats?.data_changes || 0} change={stats?.data_changes_change || 0}
//           icon={<IconDb color={isDark ? '#10B981' : '#10B981'} />}
//           iconBg="#F0FDF4" darkIconBg="#0a1a0a" isDark={isDark}
//         />
//         <MetricCard
//           title="Security Events" value={stats?.security_events || 0} change={stats?.security_events_change || 0}
//           icon={<IconShield color={isDark ? '#EF4444' : '#EF4444'} />}
//           iconBg="#FEF2F2" darkIconBg="#1a0a0a" isDark={isDark}
//         />
//       </div>

//       {/* ── Main body: table (left) + right panel ── */}
//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 500px', gap: '0', padding: '0 24px 24px' }}>

//         {/* ── LEFT: filters + table ── */}
//         <div style={{ minWidth: 0, marginRight: '16px' }}>

//           {/* Filter Bar */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : '#FFFFFF',
//             border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '12px', padding: '16px', marginBottom: '16px',
//           }}>
//             {/* Row 1: Date Range, Event Type, User, Resource Type */}
//             <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '12px' }}>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                 <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
//                   Date Range
//                 </label>
//                 <div style={{
//                   display: 'flex', alignItems: 'center', gap: '6px',
//                   padding: '7px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                   borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                   cursor: 'pointer', minWidth: '190px',
//                 }}>
//                   <IconCalendar color={isDark ? '#94a3b8' : '#64748B'} />
//                   <span style={{ fontSize: '12px', color: isDark ? '#e2e8f0' : '#0F172A' }}>{dateRangeLabel}</span>
//                 </div>
//               </div>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                 <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
//                   Event Type
//                 </label>
//                 <select
//                   value={filters.action}
//                   onChange={e => { setFilters(p => ({ ...p, action: e.target.value })); setPage(1); }}
//                   style={selectStyle}
//                 >
//                   <option value="">All Events</option>
//                   {actions.map(a => (
//                     <option key={a} value={a}>{a.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</option>
//                   ))}
//                 </select>
//               </div>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                 <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
//                   User
//                 </label>
//                 <select
//                   value={filters.user}
//                   onChange={e => { setFilters(p => ({ ...p, user: e.target.value })); setPage(1); }}
//                   style={selectStyle}
//                 >
//                   <option value="">All Users</option>
//                   {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
//                 </select>
//               </div>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                 <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
//                   Resource Type
//                 </label>
//                 <select
//                   value={filters.resourceType}
//                   onChange={e => { setFilters(p => ({ ...p, resourceType: e.target.value })); setPage(1); }}
//                   style={selectStyle}
//                 >
//                   <option value="">All Resources</option>
//                   {resourceTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                 </select>
//               </div>
//             </div>

//             {/* Row 2: Search + More Filters + Reset */}
//             <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                 <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
//                   Search
//                 </label>
//                 <div style={{ position: 'relative' }}>
//                   <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//                     <IconSearch color={isDark ? '#94a3b8' : '#94A3B8'} />
//                   </span>
//                   <input
//                     type="text"
//                     placeholder="Search by user, action, resource..."
//                     value={filters.search}
//                     onChange={e => setFilters(p => ({ ...p, search: e.target.value }))}
//                     style={{
//                       padding: '7px 12px 7px 30px',
//                       border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                       borderRadius: '8px', fontSize: '12px',
//                       color: isDark ? '#e2e8f0' : '#0F172A',
//                       background: isDark ? '#0d0d0d' : '#FFFFFF',
//                       fontFamily: sans, outline: 'none', width: '280px',
//                     }}
//                   />
//                 </div>
//               </div>
//               <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', paddingBottom: '0px', marginTop: '18px' }}>
//                 <button
//                   onClick={() => setShowMoreFilters(o => !o)}
//                   style={{
//                     display: 'flex', alignItems: 'center', gap: '6px',
//                     padding: '7px 12px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                     borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                     cursor: 'pointer', fontSize: '12px', fontWeight: 500,
//                     color: isDark ? '#94a3b8' : '#64748B', fontFamily: sans,
//                   }}
//                 >
//                   <IconFilter /> More Filters
//                 </button>
//                 <button
//                   onClick={handleReset}
//                   style={{
//                     display: 'flex', alignItems: 'center', gap: '6px',
//                     padding: '7px 12px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                     borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                     cursor: 'pointer', fontSize: '12px', fontWeight: 500,
//                     color: isDark ? '#94a3b8' : '#64748B', fontFamily: sans,
//                   }}
//                 >
//                   <IconReset /> Reset
//                 </button>
//               </div>
//             </div>

//             {/* More Filters Row */}
//             {showMoreFilters && (
//               <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`, display: 'flex', gap: '12px' }}>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                   <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>Status</label>
//                   <select
//                     value={filters.status}
//                     onChange={e => { setFilters(p => ({ ...p, status: e.target.value })); setPage(1); }}
//                     style={selectStyle}
//                   >
//                     <option value="">All Status</option>
//                     <option value="Success">Success</option>
//                     <option value="Failed">Failed</option>
//                   </select>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                   <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>Start Date</label>
//                   <input
//                     type="date" value={filters.startDate}
//                     onChange={e => setFilters(p => ({ ...p, startDate: e.target.value }))}
//                     style={{ ...selectStyle, minWidth: '140px' }}
//                   />
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                   <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>End Date</label>
//                   <input
//                     type="date" value={filters.endDate}
//                     onChange={e => setFilters(p => ({ ...p, endDate: e.target.value }))}
//                     style={{ ...selectStyle, minWidth: '140px' }}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Table header count */}
//           <div style={{ marginBottom: '10px' }}>
//             <span style={{ fontSize: '14px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A' }}>
//               Audit Events <span style={{ color: isDark ? '#94a3b8' : '#64748B', fontWeight: 400 }}>
//                 ({total.toLocaleString()})
//               </span>
//             </span>
//           </div>

//           {/* Table */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : '#FFFFFF',
//             border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '12px', overflow: 'hidden'
//           }}>
//             <div style={{ overflowX: 'auto' }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                 <thead>
//                   <tr style={{
//                     background: isDark ? '#1a1a1a' : '#F8FAFC',
//                     borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`
//                   }}>
//                     {['Time', 'User', 'Action', 'Resource', 'Resource Type', 'IP Address', 'Status', ''].map((h, i) => (
//                       <th key={i} style={{
//                         padding: '11px 14px', textAlign: 'left', fontSize: '11px',
//                         fontWeight: 600, color: isDark ? '#94a3b8' : '#64748B', whiteSpace: 'nowrap',
//                       }}>
//                         {h}{h === 'Time' ? ' ↕' : ''}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={8} style={{ textAlign: 'center', padding: '48px', color: isDark ? '#94a3b8' : '#64748B' }}>
//                         <div style={{
//                           width: '24px', height: '24px', border: '2px solid #1f1f1f',
//                           borderTopColor: '#3B82F6', borderRadius: '50%',
//                           animation: 'spin 0.8s linear infinite', margin: '0 auto 12px'
//                         }} />
//                         Loading audit logs...
//                       </td>
//                     </tr>
//                   ) : logs.length === 0 ? (
//                     <tr>
//                       <td colSpan={8} style={{ textAlign: 'center', padding: '48px', color: isDark ? '#94a3b8' : '#64748B' }}>
//                         No audit logs found
//                       </td>
//                     </tr>
//                   ) : (
//                     logs.map((log) => {
//                       const { date, time } = formatDate(log.timestamp);
//                       return (
//                         <tr
//                           key={log.id}
//                           style={{ borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`, cursor: 'pointer' }}
//                           onMouseEnter={e => (e.currentTarget.style.background = isDark ? '#1a1a1a' : '#F8FAFC')}
//                           onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
//                           onClick={() => handleRowClick(log)}
//                         >
//                           <td style={{ padding: '12px 14px', fontSize: '12px', color: isDark ? '#e2e8f0' : '#0F172A', whiteSpace: 'nowrap' }}>
//                             <div style={{ fontWeight: 500 }}>{date}</div>
//                             <div style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B', fontFamily: mono }}>{time}</div>
//                           </td>
//                           <td style={{ padding: '12px 14px' }}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                               <div style={{
//                                 width: '32px', height: '32px', borderRadius: '50%',
//                                 background: getAvatarColor(log.user_name || 'System'),
//                                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                                 fontSize: '11px', fontWeight: 700, color: '#fff', flexShrink: 0,
//                               }}>
//                                 {getInitials(log.user_name || 'System')}
//                               </div>
//                               <div>
//                                 <div style={{ fontSize: '12px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', whiteSpace: 'nowrap' }}>
//                                   {log.user_name || 'System'}
//                                 </div>
//                                 {log.user_role && (
//                                   <div style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B' }}>{log.user_role}</div>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                           <td style={{ padding: '12px 14px' }}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                               <ActionIcon action={log.action} isDark={isDark} />
//                               <div>
//                                 <div style={{ fontSize: '12px', fontWeight: 500, color: isDark ? '#e2e8f0' : '#0F172A', whiteSpace: 'nowrap' }}>
//                                   {log.action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
//                                 </div>
//                               </div>
//                             </div>
//                           </td>
//                           <td style={{ padding: '12px 14px' }}>
//                             <div style={{ fontSize: '12px', fontWeight: 500, color: '#3B82F6', cursor: 'pointer', whiteSpace: 'nowrap' }}>
//                               {log.resource || '—'}
//                             </div>
//                           </td>
//                           <td style={{ padding: '12px 14px' }}>
//                             {log.resource_type ? <ResourceTypeBadge type={log.resource_type} isDark={isDark} /> : <span style={{ color: isDark ? '#94a3b8' : '#94A3B8' }}>—</span>}
//                           </td>
//                           <td style={{ padding: '12px 14px', fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B', fontFamily: mono, whiteSpace: 'nowrap' }}>
//                             {log.ip_address || '—'}
//                           </td>
//                           <td style={{ padding: '12px 14px' }}>
//                             <StatusBadge status={log.status} isDark={isDark} />
//                           </td>
//                           <td style={{ padding: '12px 8px', textAlign: 'center' }}>
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleRowClick(log);
//                               }}
//                               style={{
//                                 padding: '4px 12px', borderRadius: '4px', fontSize: '11px',
//                                 background: isDark ? '#1a1a1a' : '#F8FAFC',
//                                 border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                                 cursor: 'pointer', color: '#3B82F6', fontFamily: sans,
//                               }}
//                             >
//                               View Details
//                             </button>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div style={{
//               padding: '12px 16px', borderTop: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//             }}>
//               <span style={{ fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B' }}>
//                 Showing {total === 0 ? 0 : ((page - 1) * perPage) + 1} to {Math.min(page * perPage, total)} of {total.toLocaleString()} results
//               </span>
//               <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
//                 <button
//                   onClick={() => setPage(1)} disabled={page === 1}
//                   style={{
//                     padding: '5px 8px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                     borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                     cursor: page === 1 ? 'not-allowed' : 'pointer',
//                     color: page === 1 ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
//                     fontSize: '12px',
//                   }}>«</button>
//                 <button
//                   onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
//                   style={{
//                     padding: '5px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                     borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                     cursor: page === 1 ? 'not-allowed' : 'pointer',
//                     color: page === 1 ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
//                     fontSize: '12px',
//                   }}>‹</button>

//                 {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                   let p: number;
//                   if (totalPages <= 5) p = i + 1;
//                   else if (page <= 3) p = i + 1;
//                   else if (page >= totalPages - 2) p = totalPages - 4 + i;
//                   else p = page - 2 + i;
//                   return (
//                     <button key={p} onClick={() => setPage(p)}
//                       style={{
//                         padding: '5px 10px', border: `1px solid ${p === page ? '#3B82F6' : (isDark ? '#1f1f1f' : '#E2E8F0')}`,
//                         borderRadius: '6px', cursor: 'pointer', fontSize: '12px',
//                         background: p === page ? '#3B82F6' : (isDark ? '#0d0d0d' : '#FFFFFF'),
//                         color: p === page ? '#fff' : (isDark ? '#e2e8f0' : '#0F172A'),
//                         fontWeight: p === page ? 600 : 400,
//                       }}>{p}</button>
//                   );
//                 })}

//                 {totalPages > 5 && page < totalPages - 2 && (
//                   <span style={{ fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B', padding: '0 2px' }}>…</span>
//                 )}
//                 {totalPages > 5 && page < totalPages - 2 && (
//                   <button onClick={() => setPage(totalPages)}
//                     style={{
//                       padding: '5px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                       borderRadius: '6px', cursor: 'pointer', fontSize: '12px',
//                       background: isDark ? '#0d0d0d' : '#FFFFFF', color: isDark ? '#e2e8f0' : '#0F172A',
//                     }}>{totalPages}</button>
//                 )}

//                 <button
//                   onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
//                   style={{
//                     padding: '5px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                     borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                     cursor: page === totalPages ? 'not-allowed' : 'pointer',
//                     color: page === totalPages ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
//                     fontSize: '12px',
//                   }}>›</button>
//                 <button
//                   onClick={() => setPage(totalPages)} disabled={page === totalPages}
//                   style={{
//                     padding: '5px 8px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//                     borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
//                     cursor: page === totalPages ? 'not-allowed' : 'pointer',
//                     color: page === totalPages ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
//                     fontSize: '12px',
//                   }}>»</button>

//                 <select
//                   value={perPage}
//                   onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
//                   style={{ ...selectStyle, minWidth: '80px', marginLeft: '8px' }}
//                 >
//                   {[10, 25, 50, 100].map(n => (
//                     <option key={n} value={n}>{n} / page</option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ── RIGHT panel ── */}
//         <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

//           {/* Events Over Time */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : '#FFFFFF',
//             border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '12px', padding: '16px'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
//               <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
//                 Events Over Time
//               </h3>
//               <select
//                 value={timeRange}
//                 onChange={e => setTimeRange(e.target.value)}
//                 style={{ ...selectStyle, minWidth: '100px', fontSize: '11px' }}
//               >
//                 <option>Last 7 Days</option>
//                 <option>Last 30 Days</option>
//                 <option>Last 90 Days</option>
//               </select>
//             </div>
//             {stats?.events_over_time && stats.events_over_time.length > 0 ? (
//               <ResponsiveContainer width="100%" height={180}>
//                 <LineChart data={stats.events_over_time} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
//                   <CartesianGrid strokeDasharray="3 3" stroke={isDark ? '#1f1f1f' : '#E2E8F0'} />
//                   <XAxis dataKey="date" tick={{ fontSize: 9, fill: isDark ? '#94a3b8' : '#64748B' }} tickLine={false} />
//                   <YAxis tick={{ fontSize: 9, fill: isDark ? '#94a3b8' : '#64748B' }} tickLine={false} axisLine={false} tickFormatter={v => v >= 1000 ? `${(v/1000).toFixed(1)}K` : v} />
//                   <Tooltip content={<ChartTooltip isDark={isDark} />} />
//                   <Line type="monotone" dataKey="count" stroke="#3B82F6" strokeWidth={2}
//                     dot={{ fill: '#3B82F6', r: 3, strokeWidth: 0 }}
//                     activeDot={{ r: 5, fill: '#3B82F6' }} />
//                 </LineChart>
//               </ResponsiveContainer>
//             ) : (
//               <div style={{ height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
//                 No data available
//               </div>
//             )}
//           </div>

//           {/* Events by Type */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : '#FFFFFF',
//             border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '12px', padding: '16px'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
//               <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
//                 Events by Type
//               </h3>
//               <button style={{ fontSize: '11px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans }}>
//                 View all
//               </button>
//             </div>
//             {stats?.events_by_type && stats.events_by_type.length > 0 ? (
//               <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                 <div style={{ position: 'relative', width: '120px', height: '120px', flexShrink: 0 }}>
//                   <ResponsiveContainer width={120} height={120}>
//                     <PieChart>
//                       <Pie
//                         data={stats.events_by_type}
//                         cx="50%" cy="50%"
//                         innerRadius={32} outerRadius={48}
//                         dataKey="count"
//                         labelLine={false}
//                         label={renderCustomLabel}
//                         startAngle={90} endAngle={-270}
//                       >
//                         {stats.events_by_type.map((_, i) => (
//                           <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
//                         ))}
//                       </Pie>
//                     </PieChart>
//                   </ResponsiveContainer>
//                   <div style={{
//                     position: 'absolute', top: '50%', left: '50%',
//                     transform: 'translate(-50%,-50%)',
//                     textAlign: 'center', pointerEvents: 'none',
//                   }}>
//                     <div style={{ fontSize: '14px', fontWeight: 700, color: isDark ? '#e2e8f0' : '#0F172A' }}>
//                       {pieTotal.toLocaleString()}
//                     </div>
//                     <div style={{ fontSize: '9px', color: isDark ? '#94a3b8' : '#64748B' }}>Total</div>
//                   </div>
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   {stats.events_by_type.map((item, i) => {
//                     const pct = pieTotal > 0 ? ((item.count / pieTotal) * 100).toFixed(1) : '0';
//                     return (
//                       <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                           <span style={{
//                             display: 'inline-block', width: '8px', height: '8px',
//                             borderRadius: '50%', background: CHART_COLORS[i % CHART_COLORS.length], flexShrink: 0,
//                           }} />
//                           <span style={{ fontSize: '11px', color: isDark ? '#94a3b8' : '#64748B' }}>{item.type}</span>
//                         </div>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//                           <span style={{ fontSize: '11px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A' }}>
//                             {item.count.toLocaleString()}
//                           </span>
//                           <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#94A3B8' }}>({pct}%)</span>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             ) : (
//               <div style={{ height: 130, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
//                 No data available
//               </div>
//             )}
//           </div>

//           {/* Top Users by Activity */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : '#FFFFFF',
//             border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '12px', padding: '16px'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
//               <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
//                 Top Users by Activity
//               </h3>
//               <button style={{ fontSize: '11px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans }}>
//                 View all
//               </button>
//             </div>
//             {stats?.top_users && stats.top_users.length > 0 ? (
//               <div>
//                 {(() => {
//                   const max = Math.max(...stats.top_users.map(u => u.count));
//                   return stats.top_users.map((u, i) => (
//                     <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
//                       <div style={{
//                         width: '28px', height: '28px', borderRadius: '50%',
//                         background: getAvatarColor(u.user),
//                         display: 'flex', alignItems: 'center', justifyContent: 'center',
//                         fontSize: '10px', fontWeight: 700, color: '#fff', flexShrink: 0,
//                       }}>
//                         {getInitials(u.user)}
//                       </div>
//                       <div style={{ flex: 1, minWidth: 0 }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
//                           <span style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#e2e8f0' : '#0F172A', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                             {u.user}
//                           </span>
//                           <span style={{ fontSize: '11px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', flexShrink: 0, marginLeft: '8px' }}>
//                             {u.count.toLocaleString()}
//                           </span>
//                         </div>
//                         <div style={{ height: '4px', background: isDark ? '#1f1f1f' : '#E2E8F0', borderRadius: '2px', overflow: 'hidden' }}>
//                           <div style={{
//                             height: '100%', borderRadius: '2px',
//                             background: CHART_COLORS[i % CHART_COLORS.length],
//                             width: `${(u.count / max) * 100}%`,
//                             transition: 'width 0.4s ease',
//                           }} />
//                         </div>
//                       </div>
//                     </div>
//                   ));
//                 })()}
//               </div>
//             ) : (
//               <div style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
//                 No data available
//               </div>
//             )}
//           </div>

//           {/* Recent Security Events */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : '#FFFFFF',
//             border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
//             borderRadius: '12px', padding: '16px'
//           }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
//               <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
//                 Recent Security Events
//               </h3>
//               <button style={{ fontSize: '11px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans }}>
//                 View all
//               </button>
//             </div>
//             {stats?.recent_security_events && stats.recent_security_events.length > 0 ? (
//               <div>
//                 {stats.recent_security_events.map((event, i) => {
//                   const isWarning = event.severity === 'warning' || event.description?.toLowerCase().includes('permission');
//                   return (
//                     <div key={i} style={{
//                       padding: '10px 0',
//                       borderBottom: i < stats.recent_security_events.length - 1 ? `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}` : 'none',
//                       display: 'flex', alignItems: 'flex-start', gap: '10px',
//                     }}>
//                       <div style={{
//                         width: '28px', height: '28px', borderRadius: '50%',
//                         background: isWarning ? (isDark ? '#1a1400' : '#FFFBEB') : (isDark ? '#1a0a0a' : '#FEF2F2'),
//                         border: `1px solid ${isWarning ? (isDark ? '#B4530940' : '#FDE68A') : (isDark ? '#DC262640' : '#FECACA')}`,
//                         display: 'flex', alignItems: 'center', justifyContent: 'center',
//                         fontSize: '12px', flexShrink: 0,
//                       }}>
//                         {isWarning ? '⚠️' : '🛡️'}
//                       </div>
//                       <div style={{ flex: 1, minWidth: 0 }}>
//                         <div style={{ fontSize: '12px', fontWeight: 500, color: isDark ? '#e2e8f0' : '#0F172A' }}>
//                           {event.description}
//                         </div>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2px' }}>
//                           <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B' }}>
//                             {event.user ? `User: ${event.user}` : 'System'}
//                           </span>
//                           {event.timestamp && (
//                             <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#94A3B8' }}>
//                               {new Date(event.timestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                       <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#94A3B8', cursor: 'pointer', flexShrink: 0 }}>▾</span>
//                     </div>
//                   );
//                 })}
//               </div>
//             ) : (
//               <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
//                 No security events
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//         input[type="date"]::-webkit-calendar-picker-indicator { cursor: pointer; opacity: ${isDark ? '0.6' : '0.6'}; }
//         select:focus, input:focus { outline: 2px solid ${isDark ? '#3B82F640' : '#BFDBFE'}; outline-offset: -1px; }
//       `}</style>
//     </div>
//   );
// }

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { AccessDeniedModal } from '../../components/AccessDeniedModal';
import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell, Legend
} from 'recharts';

/* ─── Font injection ─────────────────────────────────────────────── */
if (typeof document !== 'undefined' && !document.getElementById('al-fonts')) {
  const link = document.createElement('link');
  link.id = 'al-fonts';
  link.rel = 'stylesheet';
  link.href =
    'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap';
  document.head.appendChild(link);
}

/* ─── Design tokens ─────────────────────────────────────────────── */
const T = {
  ink: '#0F172A',
  ink2: '#1E293B',
  slate: '#64748B',
  muted: '#94A3B8',
  faint: '#CBD5E1',
  bg: '#F8FAFC',
  surface: '#FFFFFF',
  surface2: '#F8FAFC',
  bdr: '#E2E8F0',
  bdr2: '#CBD5E1',
  red: '#DC2626', redBg: '#FEF2F2', redBdr: '#FECACA',
  amb: '#B45309', ambBg: '#FFFBEB', ambBdr: '#FDE68A',
  grn: '#15803D', grnBg: '#F0FDF4', grnBdr: '#BBF7D0',
  blue: '#3B82F6', blueBg: '#EFF6FF', blueBdr: '#BFDBFE',
  indigo: '#1E40AF',
  purple: '#8B5CF6', purpleBg: '#F5F3FF', purpleBdr: '#DDD6FE',
  cyan: '#06B6D4', cyanBg: '#ECFEFF', cyanBdr: '#CFFAFE',
  orange: '#F97316', orangeBg: '#FFF7ED', orangeBdr: '#FED7AA',
};

const sans = "'Inter', system-ui, sans-serif";
const mono = "'JetBrains Mono', monospace";

/* ─── Avatar helpers ─────────────────────────────────────────────── */
const getInitials = (name: string): string => {
  if (!name || name === 'System') return 'S';
  const parts = name.split(' ');
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const getAvatarColor = (name: string): string => {
  const colors = [
    '#DC2626', '#EA580C', '#D97706', '#16A34A', '#3B82F6', '#8B5CF6',
    '#EC4899', '#06B6D4', '#84CC16', '#F97316', '#6366F1', '#14B8A6'
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i);
    hash |= 0;
  }
  return colors[Math.abs(hash) % colors.length];
};

/* ─── Types ──────────────────────────────────────────────────────── */
interface AuditEvent {
  id: number;
  timestamp: string;
  user_name: string;
  user_role?: string;
  user_id?: string;
  action: string;
  resource: string;
  resource_type: string;
  ip_address: string;
  status: string;
  details?: string;
}

interface AuditStats {
  total_events: number;
  total_events_change: number;
  user_activities: number;
  user_activities_change: number;
  data_changes: number;
  data_changes_change: number;
  security_events: number;
  security_events_change: number;
  events_over_time: Array<{ date: string; count: number }>;
  events_by_type: Array<{ type: string; count: number }>;
  top_users: Array<{ user: string; count: number }>;
  recent_security_events: Array<{ description: string; user?: string; timestamp?: string; severity?: string }>;
}

interface FilterState {
  startDate: string;
  endDate: string;
  user: string;
  action: string;
  resourceType: string;
  status: string;
  search: string;
}

const CHART_COLORS = ['#3B82F6', '#DC2626', '#16A34A', '#8B5CF6', '#B45309', '#06B6D4'];

/* ─── Resource Type Badge ────────────────────────────────────────── */
const ResourceTypeBadge: React.FC<{ type: string; isDark?: boolean }> = ({ type, isDark }) => {
  const typeMap: Record<string, { bg: string; color: string; border: string; darkBg: string }> = {
    Vendor:    { bg: '#EFF6FF', color: '#3B82F6', border: '#BFDBFE', darkBg: '#0a1628' },
    Scan:      { bg: '#F5F3FF', color: '#8B5CF6', border: '#DDD6FE', darkBg: '#150a1f' },
    Indicator: { bg: '#FFFBEB', color: '#B45309', border: '#FDE68A', darkBg: '#1a1400' },
    User:      { bg: '#ECFEFF', color: '#06B6D4', border: '#CFFAFE', darkBg: '#0a1a1a' },
    Report:    { bg: '#F0FDF4', color: '#15803D', border: '#BBF7D0', darkBg: '#0a1a0a' },
    Auth:      { bg: '#FFF7ED', color: '#F97316', border: '#FED7AA', darkBg: '#1a0f00' },
  };
  const style = typeMap[type] || { bg: '#F8FAFC', color: '#64748B', border: '#E2E8F0', darkBg: '#1a1a1a' };
  const bg = isDark ? style.darkBg : style.bg;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: 600,
      background: bg, color: style.color, border: `1px solid ${isDark ? style.color + '40' : style.border}`,
    }}>
      {type}
    </span>
  );
};

/* ─── Status Badge ───────────────────────────────────────────────── */
const StatusBadge: React.FC<{ status: string; isDark?: boolean }> = ({ status, isDark }) => {
  const isSuccess = status === 'Success';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '4px',
      padding: '3px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: 600,
      background: isSuccess ? (isDark ? '#0a1a0a' : '#F0FDF4') : (isDark ? '#1a0a0a' : '#FEF2F2'),
      color: isSuccess ? '#15803D' : '#DC2626',
      border: `1px solid ${isSuccess ? (isDark ? '#15803D40' : '#BBF7D0') : (isDark ? '#DC262640' : '#FECACA')}`,
    }}>
      <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: isSuccess ? '#15803D' : '#DC2626' }} />
      {status}
    </span>
  );
};

/* ─── Metric Card ────────────────────────────────────────────────── */
const MetricCard: React.FC<{
  title: string;
  value: number;
  change: number;
  icon: React.ReactNode;
  iconBg: string;
  darkIconBg: string;
  isDark?: boolean;
}> = ({ title, value, change, icon, iconBg, darkIconBg, isDark }) => {
  const isPositive = change >= 0;
  const bg = isDark ? darkIconBg : iconBg;
  return (
    <div style={{
      background: isDark ? '#0d0d0d' : '#FFFFFF',
      border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
      borderRadius: '12px',
      padding: '20px', display: 'flex', alignItems: 'flex-start', gap: '16px',
    }}>
      <div style={{
        width: '44px', height: '44px', borderRadius: '10px', background: bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
      }}>
        {icon}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '12px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B', marginBottom: '6px' }}>
          {title}
        </div>
        <div style={{ fontSize: '28px', fontWeight: 700, color: isDark ? '#e2e8f0' : '#0F172A', lineHeight: 1, marginBottom: '6px' }}>
          {value.toLocaleString()}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ fontSize: '12px', fontWeight: 600, color: isPositive ? '#15803D' : '#DC2626' }}>
            {isPositive ? '↑' : '↓'} {Math.abs(change)}%
          </span>
          <span style={{ fontSize: '11px', color: isDark ? '#94a3b8' : '#64748B' }}>vs previous period</span>
        </div>
      </div>
    </div>
  );
};

/* ─── Detail Modal Component ─────────────────────────────────────── */
interface DetailModalProps {
  open: boolean;
  onClose: () => void;
  log: AuditEvent | null;
  isDark?: boolean;
}

const DetailModal: React.FC<DetailModalProps> = ({ open, onClose, log, isDark }) => {
  if (!open || !log) return null;

  const { date, time } = (() => {
    const d = new Date(log.timestamp);
    return {
      date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
    };
  })();

  const colors = {
    bg: isDark ? '#0d0d0d' : '#FFFFFF',
    border: isDark ? '#1f1f1f' : '#E2E8F0',
    text: isDark ? '#e2e8f0' : '#0F172A',
    muted: isDark ? '#94a3b8' : '#64748B',
    surface2: isDark ? '#1a1a1a' : '#F8FAFC',
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 2000,
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(2px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: '560px',
          background: colors.bg, borderRadius: '16px',
          border: `1px solid ${colors.border}`, overflow: 'hidden',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Header */}
        <div style={{
          padding: '18px 20px', borderBottom: `1px solid ${colors.border}`,
          background: colors.bg, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: colors.text }}>Event Details</h3>
            <p style={{ margin: '2px 0 0', fontSize: '11px', color: colors.muted }}>Log ID: {log.id}</p>
          </div>
          <button
            onClick={onClose}
            style={{
              width: '28px', height: '28px', borderRadius: '6px',
              border: `1px solid ${colors.border}`, background: colors.bg,
              cursor: 'pointer', fontSize: '16px', color: colors.muted,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'grid', gap: '14px' }}>
            <DetailRow label="Action" value={log.action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} colors={colors} />
            <DetailRow label="User" value={log.user_name || 'System'} colors={colors} />
            <DetailRow label="Resource" value={log.resource || '—'} colors={colors} />
            <DetailRow label="Resource Type" value={log.resource_type || '—'} colors={colors} />
            <DetailRow label="IP Address" value={log.ip_address || '—'} colors={colors} />
            <DetailRow label="Status" value={log.status} colors={colors} />
            <DetailRow label="Date & Time" value={`${date} at ${time}`} colors={colors} />
            {log.details && (
              <div>
                <div style={{ fontSize: '11px', fontWeight: 600, color: colors.muted, marginBottom: '6px', textTransform: 'uppercase' }}>
                  Details
                </div>
                <div style={{
                  padding: '10px 12px', background: colors.surface2, borderRadius: '8px',
                  fontSize: '12px', color: colors.text, border: `1px solid ${colors.border}`,
                }}>
                  {log.details}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '14px 20px', borderTop: `1px solid ${colors.border}`, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '6px 16px', borderRadius: '6px', fontSize: '12px', fontWeight: 500,
              background: isDark ? '#3B82F6' : '#0F172A', border: 'none', color: '#fff', cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const DetailRow: React.FC<{ label: string; value: string; colors: any }> = ({ label, value, colors }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
    <div style={{ width: '100px', fontSize: '11px', fontWeight: 600, color: colors.muted, textTransform: 'uppercase', flexShrink: 0 }}>
      {label}
    </div>
    <div style={{ fontSize: '12px', color: colors.text, wordBreak: 'break-word', flex: 1 }}>
      {value}
    </div>
  </div>
);

/* ─── Action icon ────────────────────────────────────────────────── */
const ActionIcon: React.FC<{ action: string; isDark?: boolean }> = ({ action, isDark }) => {
  const a = action.toLowerCase();
  let bg = isDark ? '#0a1628' : '#EFF6FF', color = '#3B82F6', symbol = '📋';
  if (a.includes('update') || a.includes('modified') || a.includes('changed')) { bg = isDark ? '#1a1400' : '#FFFBEB'; color = '#B45309'; symbol = '✏️'; }
  else if (a.includes('create') || a.includes('add') || a.includes('new')) { bg = isDark ? '#0a1a0a' : '#F0FDF4'; color = '#15803D'; symbol = '➕'; }
  else if (a.includes('delete') || a.includes('remove')) { bg = isDark ? '#1a0a0a' : '#FEF2F2'; color = '#DC2626'; symbol = '🗑️'; }
  else if (a.includes('login') || a.includes('auth')) { bg = isDark ? '#150a1f' : '#F5F3FF'; color = '#8B5CF6'; symbol = '🔐'; }
  else if (a.includes('scan')) { bg = isDark ? '#0a1a1a' : '#ECFEFF'; color = '#06B6D4'; symbol = '🔍'; }
  else if (a.includes('download') || a.includes('export')) { bg = isDark ? '#0a1a0a' : '#F0FDF4'; color = '#15803D'; symbol = '⬇️'; }
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: '28px', height: '28px', borderRadius: '6px', background: bg,
      fontSize: '13px', flexShrink: 0,
    }}>
      {symbol}
    </span>
  );
};

/* ─── Custom Tooltip for charts ──────────────────────────────────── */
const ChartTooltip: React.FC<any> = ({ active, payload, label, isDark }) => {
  if (!active || !payload?.length) return null;
  const colors = {
    bg: isDark ? '#0d0d0d' : '#FFFFFF',
    border: isDark ? '#1f1f1f' : '#E2E8F0',
    text: isDark ? '#e2e8f0' : '#0F172A',
  };
  return (
    <div style={{
      background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: '8px',
      padding: '8px 12px', fontSize: '12px', color: colors.text, boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    }}>
      <div style={{ fontWeight: 600, marginBottom: '2px' }}>{label}</div>
      {payload.map((p: any, i: number) => (
        <div key={i} style={{ color: p.color }}>{p.value?.toLocaleString()}</div>
      ))}
    </div>
  );
};

/* ─── Icons (inline SVG) ─────────────────────────────────────────── */
const IconDoc = ({ color = '#6366F1' }) => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
    <rect x="4" y="2" width="16" height="20" rx="2" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="8" y1="8" x2="16" y2="8" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="12" x2="16" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="16" x2="12" y2="16" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconUser = ({ color = '#3B82F6' }) => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none"/>
  </svg>
);
const IconDb = ({ color = '#10B981' }) => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
    <ellipse cx="12" cy="6" rx="8" ry="3" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M4 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M4 12v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);
const IconShield = ({ color = '#EF4444' }) => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
    <path d="M12 3L4 6v6c0 5.25 3.5 10.15 8 11.5C16.5 22.15 20 17.25 20 12V6l-8-3z" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M9 12l2 2 4-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const IconCalendar = ({ color = '#64748B' }) => (
  <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconSearch = ({ color = '#94A3B8' }) => (
  <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="7" stroke={color} strokeWidth="2"/>
    <line x1="16.5" y1="16.5" x2="21" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconExport = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
    <path d="M12 3v12M8 11l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconSettings = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconFilter = () => (
  <svg width="13" height="13" fill="none" viewBox="0 0 24 24">
    <path d="M3 6h18M7 12h10M11 18h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconReset = () => (
  <svg width="13" height="13" fill="none" viewBox="0 0 24 24">
    <path d="M4 4v5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.07 13A8 8 0 1020 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

/* ─── Main Component ─────────────────────────────────────────────── */
export default function AuditLogs() {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // ─── Theme Colors ──────────────────────────────────────────────────────────
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';

  const themeColors = {
    text: isDark ? '#e2e8f0' : '#0F172A',
    muted: isDark ? '#94a3b8' : '#64748B',
    background: isDark ? '#000000' : '#F8FAFC',
    cardBg: isDark ? '#0d0d0d' : '#FFFFFF',
    border: isDark ? '#1f1f1f' : '#E2E8F0',
    hover: isDark ? '#141414' : '#F8FAFC',
    paper: isDark ? '#0d0d0d' : '#FFFFFF',
    inputBg: isDark ? '#0d0d0d' : '#FFFFFF',
    chipBg: isDark ? '#1a1a1a' : '#F1F5F9',
    surface: isDark ? '#0d0d0d' : '#FFFFFF',
    surface2: isDark ? '#1a1a1a' : '#F8FAFC',
  };

  // ─── Access Denied State ──────────────────────────────────────────────────
  const [accessDenied, setAccessDenied] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [selectedLog, setSelectedLog] = useState<AuditEvent | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [filters, setFilters] = useState<FilterState>({
    startDate: '',
    endDate: '',
    user: '',
    action: '',
    resourceType: '',
    status: '',
    search: '',
  });

  const [dateRangeLabel, setDateRangeLabel] = useState('May 1, 2024 – May 31, 2024');
  const [timeRange, setTimeRange] = useState('Last 7 Days');
  const [showMoreFilters, setShowMoreFilters] = useState(false);

  // ─── Check Admin Access ──────────────────────────────────────────────────
  useEffect(() => {
    // Check if user is admin
    if (user && user.role !== 'admin' && user.role !== 'super_admin') {
      setAccessDenied(true);
    }
  }, [user]);

  // ─── Fetch Data ──────────────────────────────────────────────────────────
  const logParams: Record<string, string | number> = { page, per_page: perPage };
  if (filters.startDate) logParams.start_date = filters.startDate;
  if (filters.endDate) logParams.end_date = filters.endDate;
  if (filters.user) logParams.user_id = filters.user;
  if (filters.action) logParams.action = filters.action;
  if (filters.resourceType) logParams.resource_type = filters.resourceType;
  if (filters.search) logParams.search = filters.search;

  const statsQuery = useQuery({
    queryKey: ['audit', 'stats'],
    queryFn: async () => (await api.get('/v1/audit/stats')).data as AuditStats,
    enabled: !accessDenied,
  });
  const logsQuery = useQuery({
    queryKey: ['audit', 'logs', logParams],
    queryFn: async () => (await api.get('/v1/audit/logs', { params: logParams })).data as { logs: AuditEvent[]; total: number },
    enabled: !accessDenied,
    placeholderData: keepPreviousData,
  });
  const usersQuery = useQuery({
    queryKey: ['users', 'list', { include_inactive: false }],
    queryFn: async () => (await api.get('/v1/users')).data as Array<{ id: string; name: string }>,
    enabled: !accessDenied,
  });
  const actionsQuery = useQuery({
    queryKey: ['audit', 'actions'],
    queryFn: async () => ((await api.get('/v1/audit/actions')).data.actions || []) as string[],
    enabled: !accessDenied,
  });
  const resourceTypesQuery = useQuery({
    queryKey: ['audit', 'resource-types'],
    queryFn: async () => ((await api.get('/v1/audit/resource-types')).data.resource_types || []) as string[],
    enabled: !accessDenied,
  });

  const stats: AuditStats | null = statsQuery.data ?? null;
  const logs: AuditEvent[] = logsQuery.data?.logs ?? [];
  const total = logsQuery.data?.total ?? 0;
  const loading = logsQuery.isPending;
  const users = usersQuery.data ?? [];
  const actions = actionsQuery.data ?? [];
  const resourceTypes = resourceTypesQuery.data ?? [];

  useEffect(() => {
    if (statsQuery.error) console.error('Failed to fetch stats:', statsQuery.error);
    if (logsQuery.error) console.error('Failed to fetch logs:', logsQuery.error);
  }, [statsQuery.error, logsQuery.error]);

  const formatDate = (timestamp: string) => {
    const d = new Date(timestamp);
    return {
      date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
    };
  };

  const totalPages = Math.ceil(total / perPage);

  const handleReset = () => {
    setFilters({ startDate: '', endDate: '', user: '', action: '', resourceType: '', status: '', search: '' });
    setPage(1);
  };

  const handleRowClick = (log: AuditEvent) => {
    setSelectedLog(log);
    setModalOpen(true);
  };

  const selectStyle: React.CSSProperties = {
    padding: '7px 10px',
    border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
    borderRadius: '8px',
    fontSize: '12px',
    background: isDark ? '#0d0d0d' : '#FFFFFF',
    fontFamily: sans,
    cursor: 'pointer',
    color: isDark ? '#e2e8f0' : '#0F172A',
    outline: 'none',
    minWidth: '120px',
  };

  /* ── Pie chart total ── */
  const pieTotal = stats?.events_by_type?.reduce((s, e) => s + e.count, 0) || 0;

  /* ── Custom Pie label ── */
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) => {
    if (percent < 0.05) return null;
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize={10} fontWeight={600}>
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  // ─── Access Denied Handler ──────────────────────────────────────────────
  const handleAccessDeniedClose = () => {
    setAccessDenied(false);
    navigate('/dashboard');
  };

  // ─── Access Denied Modal ──────────────────────────────────────────────
  if (accessDenied) {
    return (
      <AccessDeniedModal
        open={true}
        onClose={handleAccessDeniedClose}
        pageName="Audit Logs"
      />
    );
  }

  return (
    <div style={{ fontFamily: sans, background: isDark ? '#000000' : '#F8FAFC', minHeight: '100vh' }}>

      {/* Detail Modal */}
      <DetailModal open={modalOpen} onClose={() => setModalOpen(false)} log={selectedLog} isDark={isDark} />

      {/* ── Header ── */}
      <div style={{
        padding: '16px 24px',
        borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
        background: isDark ? '#0d0d0d' : '#FFFFFF',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <h1 style={{ fontSize: '18px', fontWeight: 700, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
              Audit Logs
            </h1>
            <span style={{
              width: '16px', height: '16px', borderRadius: '50%', background: isDark ? '#1f1f1f' : '#E2E8F0',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B', cursor: 'pointer', fontWeight: 600,
            }}>i</span>
          </div>
          <p style={{ fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B', marginTop: '2px', margin: '2px 0 0' }}>
            Track all user activities and system events across the platform.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div style={{ position: 'relative', display: 'inline-flex' }}>
            <button style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              padding: '8px 14px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
              borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
              cursor: 'pointer', fontSize: '12px', fontWeight: 500,
              color: isDark ? '#e2e8f0' : '#0F172A', fontFamily: sans,
            }}>
              <IconExport /> Export
              <span style={{ marginLeft: '4px', color: isDark ? '#94a3b8' : '#64748B' }}>▾</span>
            </button>
          </div>
          <button style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '8px 14px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
            cursor: 'pointer', fontSize: '12px', fontWeight: 500,
            color: isDark ? '#e2e8f0' : '#0F172A', fontFamily: sans,
          }}>
            <IconSettings /> Settings
          </button>
        </div>
      </div>

      {/* ── Metric Cards ── */}
      <div style={{ padding: '20px 24px 16px', display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '16px' }}>
        <MetricCard
          title="Total Events" value={stats?.total_events || 0} change={stats?.total_events_change || 0}
          icon={<IconDoc color={isDark ? '#8B5CF6' : '#6366F1'} />}
          iconBg="#F5F3FF" darkIconBg="#150a1f" isDark={isDark}
        />
        <MetricCard
          title="User Activities" value={stats?.user_activities || 0} change={stats?.user_activities_change || 0}
          icon={<IconUser color={isDark ? '#3B82F6' : '#3B82F6'} />}
          iconBg="#EFF6FF" darkIconBg="#0a1628" isDark={isDark}
        />
        <MetricCard
          title="Data Changes" value={stats?.data_changes || 0} change={stats?.data_changes_change || 0}
          icon={<IconDb color={isDark ? '#10B981' : '#10B981'} />}
          iconBg="#F0FDF4" darkIconBg="#0a1a0a" isDark={isDark}
        />
        <MetricCard
          title="Security Events" value={stats?.security_events || 0} change={stats?.security_events_change || 0}
          icon={<IconShield color={isDark ? '#EF4444' : '#EF4444'} />}
          iconBg="#FEF2F2" darkIconBg="#1a0a0a" isDark={isDark}
        />
      </div>

      {/* ── Main body: table (left) + right panel ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 500px', gap: '0', padding: '0 24px 24px' }}>

        {/* ── LEFT: filters + table ── */}
        <div style={{ minWidth: 0, marginRight: '16px' }}>

          {/* Filter Bar */}
          <div style={{
            background: isDark ? '#0d0d0d' : '#FFFFFF',
            border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '12px', padding: '16px', marginBottom: '16px',
          }}>
            {/* Row 1: Date Range, Event Type, User, Resource Type */}
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '12px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
                  Date Range
                </label>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  padding: '7px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                  borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                  cursor: 'pointer', minWidth: '190px',
                }}>
                  <IconCalendar color={isDark ? '#94a3b8' : '#64748B'} />
                  <span style={{ fontSize: '12px', color: isDark ? '#e2e8f0' : '#0F172A' }}>{dateRangeLabel}</span>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
                  Event Type
                </label>
                <select
                  value={filters.action}
                  onChange={e => { setFilters(p => ({ ...p, action: e.target.value })); setPage(1); }}
                  style={selectStyle}
                >
                  <option value="">All Events</option>
                  {actions.map(a => (
                    <option key={a} value={a}>{a.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</option>
                  ))}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
                  User
                </label>
                <select
                  value={filters.user}
                  onChange={e => { setFilters(p => ({ ...p, user: e.target.value })); setPage(1); }}
                  style={selectStyle}
                >
                  <option value="">All Users</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
                  Resource Type
                </label>
                <select
                  value={filters.resourceType}
                  onChange={e => { setFilters(p => ({ ...p, resourceType: e.target.value })); setPage(1); }}
                  style={selectStyle}
                >
                  <option value="">All Resources</option>
                  {resourceTypes.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
            </div>

            {/* Row 2: Search + More Filters + Reset */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>
                  Search
                </label>
                <div style={{ position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    <IconSearch color={isDark ? '#94a3b8' : '#94A3B8'} />
                  </span>
                  <input
                    type="text"
                    placeholder="Search by user, action, resource..."
                    value={filters.search}
                    onChange={e => setFilters(p => ({ ...p, search: e.target.value }))}
                    style={{
                      padding: '7px 12px 7px 30px',
                      border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                      borderRadius: '8px', fontSize: '12px',
                      color: isDark ? '#e2e8f0' : '#0F172A',
                      background: isDark ? '#0d0d0d' : '#FFFFFF',
                      fontFamily: sans, outline: 'none', width: '280px',
                    }}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', paddingBottom: '0px', marginTop: '18px' }}>
                <button
                  onClick={() => setShowMoreFilters(o => !o)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    padding: '7px 12px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                    borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                    cursor: 'pointer', fontSize: '12px', fontWeight: 500,
                    color: isDark ? '#94a3b8' : '#64748B', fontFamily: sans,
                  }}
                >
                  <IconFilter /> More Filters
                </button>
                <button
                  onClick={handleReset}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '6px',
                    padding: '7px 12px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                    borderRadius: '8px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                    cursor: 'pointer', fontSize: '12px', fontWeight: 500,
                    color: isDark ? '#94a3b8' : '#64748B', fontFamily: sans,
                  }}
                >
                  <IconReset /> Reset
                </button>
              </div>
            </div>

            {/* More Filters Row */}
            {showMoreFilters && (
              <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`, display: 'flex', gap: '12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>Status</label>
                  <select
                    value={filters.status}
                    onChange={e => { setFilters(p => ({ ...p, status: e.target.value })); setPage(1); }}
                    style={selectStyle}
                  >
                    <option value="">All Status</option>
                    <option value="Success">Success</option>
                    <option value="Failed">Failed</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>Start Date</label>
                  <input
                    type="date" value={filters.startDate}
                    onChange={e => setFilters(p => ({ ...p, startDate: e.target.value }))}
                    style={{ ...selectStyle, minWidth: '140px' }}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#94a3b8' : '#64748B' }}>End Date</label>
                  <input
                    type="date" value={filters.endDate}
                    onChange={e => setFilters(p => ({ ...p, endDate: e.target.value }))}
                    style={{ ...selectStyle, minWidth: '140px' }}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Table header count */}
          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontSize: '14px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A' }}>
              Audit Events <span style={{ color: isDark ? '#94a3b8' : '#64748B', fontWeight: 400 }}>
                ({total.toLocaleString()})
              </span>
            </span>
          </div>

          {/* Table */}
          <div style={{
            background: isDark ? '#0d0d0d' : '#FFFFFF',
            border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '12px', overflow: 'hidden'
          }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{
                    background: isDark ? '#1a1a1a' : '#F8FAFC',
                    borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`
                  }}>
                    {['Time', 'User', 'Action', 'Resource', 'Resource Type', 'IP Address', 'Status', ''].map((h, i) => (
                      <th key={i} style={{
                        padding: '11px 14px', textAlign: 'left', fontSize: '11px',
                        fontWeight: 600, color: isDark ? '#94a3b8' : '#64748B', whiteSpace: 'nowrap',
                      }}>
                        {h}{h === 'Time' ? ' ↕' : ''}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={8} style={{ textAlign: 'center', padding: '48px', color: isDark ? '#94a3b8' : '#64748B' }}>
                        <div style={{
                          width: '24px', height: '24px', border: '2px solid #1f1f1f',
                          borderTopColor: '#3B82F6', borderRadius: '50%',
                          animation: 'spin 0.8s linear infinite', margin: '0 auto 12px'
                        }} />
                        Loading audit logs...
                      </td>
                    </tr>
                  ) : logs.length === 0 ? (
                    <tr>
                      <td colSpan={8} style={{ textAlign: 'center', padding: '48px', color: isDark ? '#94a3b8' : '#64748B' }}>
                        No audit logs found
                      </td>
                    </tr>
                  ) : (
                    logs.map((log) => {
                      const { date, time } = formatDate(log.timestamp);
                      return (
                        <tr
                          key={log.id}
                          style={{ borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`, cursor: 'pointer' }}
                          onMouseEnter={e => (e.currentTarget.style.background = isDark ? '#1a1a1a' : '#F8FAFC')}
                          onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
                          onClick={() => handleRowClick(log)}
                        >
                          <td style={{ padding: '12px 14px', fontSize: '12px', color: isDark ? '#e2e8f0' : '#0F172A', whiteSpace: 'nowrap' }}>
                            <div style={{ fontWeight: 500 }}>{date}</div>
                            <div style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B', fontFamily: mono }}>{time}</div>
                          </td>
                          <td style={{ padding: '12px 14px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <div style={{
                                width: '32px', height: '32px', borderRadius: '50%',
                                background: getAvatarColor(log.user_name || 'System'),
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '11px', fontWeight: 700, color: '#fff', flexShrink: 0,
                              }}>
                                {getInitials(log.user_name || 'System')}
                              </div>
                              <div>
                                <div style={{ fontSize: '12px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', whiteSpace: 'nowrap' }}>
                                  {log.user_name || 'System'}
                                </div>
                                {log.user_role && (
                                  <div style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B' }}>{log.user_role}</div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: '12px 14px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <ActionIcon action={log.action} isDark={isDark} />
                              <div>
                                <div style={{ fontSize: '12px', fontWeight: 500, color: isDark ? '#e2e8f0' : '#0F172A', whiteSpace: 'nowrap' }}>
                                  {log.action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: '12px 14px' }}>
                            <div style={{ fontSize: '12px', fontWeight: 500, color: '#3B82F6', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                              {log.resource || '—'}
                            </div>
                          </td>
                          <td style={{ padding: '12px 14px' }}>
                            {log.resource_type ? <ResourceTypeBadge type={log.resource_type} isDark={isDark} /> : <span style={{ color: isDark ? '#94a3b8' : '#94A3B8' }}>—</span>}
                          </td>
                          <td style={{ padding: '12px 14px', fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B', fontFamily: mono, whiteSpace: 'nowrap' }}>
                            {log.ip_address || '—'}
                          </td>
                          <td style={{ padding: '12px 14px' }}>
                            <StatusBadge status={log.status} isDark={isDark} />
                          </td>
                          <td style={{ padding: '12px 8px', textAlign: 'center' }}>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRowClick(log);
                              }}
                              style={{
                                padding: '4px 12px', borderRadius: '4px', fontSize: '11px',
                                background: isDark ? '#1a1a1a' : '#F8FAFC',
                                border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                                cursor: 'pointer', color: '#3B82F6', fontFamily: sans,
                              }}
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div style={{
              padding: '12px 16px', borderTop: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <span style={{ fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B' }}>
                Showing {total === 0 ? 0 : ((page - 1) * perPage) + 1} to {Math.min(page * perPage, total)} of {total.toLocaleString()} results
              </span>
              <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <button
                  onClick={() => setPage(1)} disabled={page === 1}
                  style={{
                    padding: '5px 8px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                    borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                    cursor: page === 1 ? 'not-allowed' : 'pointer',
                    color: page === 1 ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
                    fontSize: '12px',
                  }}>«</button>
                <button
                  onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
                  style={{
                    padding: '5px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                    borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                    cursor: page === 1 ? 'not-allowed' : 'pointer',
                    color: page === 1 ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
                    fontSize: '12px',
                  }}>‹</button>

                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let p: number;
                  if (totalPages <= 5) p = i + 1;
                  else if (page <= 3) p = i + 1;
                  else if (page >= totalPages - 2) p = totalPages - 4 + i;
                  else p = page - 2 + i;
                  return (
                    <button key={p} onClick={() => setPage(p)}
                      style={{
                        padding: '5px 10px', border: `1px solid ${p === page ? '#3B82F6' : (isDark ? '#1f1f1f' : '#E2E8F0')}`,
                        borderRadius: '6px', cursor: 'pointer', fontSize: '12px',
                        background: p === page ? '#3B82F6' : (isDark ? '#0d0d0d' : '#FFFFFF'),
                        color: p === page ? '#fff' : (isDark ? '#e2e8f0' : '#0F172A'),
                        fontWeight: p === page ? 600 : 400,
                      }}>{p}</button>
                  );
                })}

                {totalPages > 5 && page < totalPages - 2 && (
                  <span style={{ fontSize: '12px', color: isDark ? '#94a3b8' : '#64748B', padding: '0 2px' }}>…</span>
                )}
                {totalPages > 5 && page < totalPages - 2 && (
                  <button onClick={() => setPage(totalPages)}
                    style={{
                      padding: '5px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                      borderRadius: '6px', cursor: 'pointer', fontSize: '12px',
                      background: isDark ? '#0d0d0d' : '#FFFFFF', color: isDark ? '#e2e8f0' : '#0F172A',
                    }}>{totalPages}</button>
                )}

                <button
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
                  style={{
                    padding: '5px 10px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                    borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                    cursor: page === totalPages ? 'not-allowed' : 'pointer',
                    color: page === totalPages ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
                    fontSize: '12px',
                  }}>›</button>
                <button
                  onClick={() => setPage(totalPages)} disabled={page === totalPages}
                  style={{
                    padding: '5px 8px', border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
                    borderRadius: '6px', background: isDark ? '#0d0d0d' : '#FFFFFF',
                    cursor: page === totalPages ? 'not-allowed' : 'pointer',
                    color: page === totalPages ? (isDark ? '#94a3b8' : '#94A3B8') : (isDark ? '#e2e8f0' : '#0F172A'),
                    fontSize: '12px',
                  }}>»</button>

                <select
                  value={perPage}
                  onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
                  style={{ ...selectStyle, minWidth: '80px', marginLeft: '8px' }}
                >
                  {[10, 25, 50, 100].map(n => (
                    <option key={n} value={n}>{n} / page</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* ── RIGHT panel ── */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* Events Over Time */}
          <div style={{
            background: isDark ? '#0d0d0d' : '#FFFFFF',
            border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '12px', padding: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
              <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
                Events Over Time
              </h3>
              <select
                value={timeRange}
                onChange={e => setTimeRange(e.target.value)}
                style={{ ...selectStyle, minWidth: '100px', fontSize: '11px' }}
              >
                <option>Last 7 Days</option>
                <option>Last 30 Days</option>
                <option>Last 90 Days</option>
              </select>
            </div>
            {stats?.events_over_time && stats.events_over_time.length > 0 ? (
              <ResponsiveContainer width="100%" height={180}>
                <LineChart data={stats.events_over_time} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke={isDark ? '#1f1f1f' : '#E2E8F0'} />
                  <XAxis dataKey="date" tick={{ fontSize: 9, fill: isDark ? '#94a3b8' : '#64748B' }} tickLine={false} />
                  <YAxis tick={{ fontSize: 9, fill: isDark ? '#94a3b8' : '#64748B' }} tickLine={false} axisLine={false} tickFormatter={v => v >= 1000 ? `${(v/1000).toFixed(1)}K` : v} />
                  <Tooltip content={<ChartTooltip isDark={isDark} />} />
                  <Line type="monotone" dataKey="count" stroke="#3B82F6" strokeWidth={2}
                    dot={{ fill: '#3B82F6', r: 3, strokeWidth: 0 }}
                    activeDot={{ r: 5, fill: '#3B82F6' }} />
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <div style={{ height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
                No data available
              </div>
            )}
          </div>

          {/* Events by Type */}
          <div style={{
            background: isDark ? '#0d0d0d' : '#FFFFFF',
            border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '12px', padding: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
                Events by Type
              </h3>
              <button style={{ fontSize: '11px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans }}>
                View all
              </button>
            </div>
            {stats?.events_by_type && stats.events_by_type.length > 0 ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ position: 'relative', width: '120px', height: '120px', flexShrink: 0 }}>
                  <ResponsiveContainer width={120} height={120}>
                    <PieChart>
                      <Pie
                        data={stats.events_by_type}
                        cx="50%" cy="50%"
                        innerRadius={32} outerRadius={48}
                        dataKey="count"
                        labelLine={false}
                        label={renderCustomLabel}
                        startAngle={90} endAngle={-270}
                      >
                        {stats.events_by_type.map((_, i) => (
                          <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                  <div style={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%,-50%)',
                    textAlign: 'center', pointerEvents: 'none',
                  }}>
                    <div style={{ fontSize: '14px', fontWeight: 700, color: isDark ? '#e2e8f0' : '#0F172A' }}>
                      {pieTotal.toLocaleString()}
                    </div>
                    <div style={{ fontSize: '9px', color: isDark ? '#94a3b8' : '#64748B' }}>Total</div>
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  {stats.events_by_type.map((item, i) => {
                    const pct = pieTotal > 0 ? ((item.count / pieTotal) * 100).toFixed(1) : '0';
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{
                            display: 'inline-block', width: '8px', height: '8px',
                            borderRadius: '50%', background: CHART_COLORS[i % CHART_COLORS.length], flexShrink: 0,
                          }} />
                          <span style={{ fontSize: '11px', color: isDark ? '#94a3b8' : '#64748B' }}>{item.type}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '11px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A' }}>
                            {item.count.toLocaleString()}
                          </span>
                          <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#94A3B8' }}>({pct}%)</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div style={{ height: 130, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
                No data available
              </div>
            )}
          </div>

          {/* Top Users by Activity */}
          <div style={{
            background: isDark ? '#0d0d0d' : '#FFFFFF',
            border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '12px', padding: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
              <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
                Top Users by Activity
              </h3>
              <button style={{ fontSize: '11px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans }}>
                View all
              </button>
            </div>
            {stats?.top_users && stats.top_users.length > 0 ? (
              <div>
                {(() => {
                  const max = Math.max(...stats.top_users.map(u => u.count));
                  return stats.top_users.map((u, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                      <div style={{
                        width: '28px', height: '28px', borderRadius: '50%',
                        background: getAvatarColor(u.user),
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '10px', fontWeight: 700, color: '#fff', flexShrink: 0,
                      }}>
                        {getInitials(u.user)}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                          <span style={{ fontSize: '11px', fontWeight: 500, color: isDark ? '#e2e8f0' : '#0F172A', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {u.user}
                          </span>
                          <span style={{ fontSize: '11px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', flexShrink: 0, marginLeft: '8px' }}>
                            {u.count.toLocaleString()}
                          </span>
                        </div>
                        <div style={{ height: '4px', background: isDark ? '#1f1f1f' : '#E2E8F0', borderRadius: '2px', overflow: 'hidden' }}>
                          <div style={{
                            height: '100%', borderRadius: '2px',
                            background: CHART_COLORS[i % CHART_COLORS.length],
                            width: `${(u.count / max) * 100}%`,
                            transition: 'width 0.4s ease',
                          }} />
                        </div>
                      </div>
                    </div>
                  ));
                })()}
              </div>
            ) : (
              <div style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
                No data available
              </div>
            )}
          </div>

          {/* Recent Security Events */}
          <div style={{
            background: isDark ? '#0d0d0d' : '#FFFFFF',
            border: `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}`,
            borderRadius: '12px', padding: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#0F172A', margin: 0 }}>
                Recent Security Events
              </h3>
              <button style={{ fontSize: '11px', color: '#3B82F6', background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans }}>
                View all
              </button>
            </div>
            {stats?.recent_security_events && stats.recent_security_events.length > 0 ? (
              <div>
                {stats.recent_security_events.map((event, i) => {
                  const isWarning = event.severity === 'warning' || event.description?.toLowerCase().includes('permission');
                  return (
                    <div key={i} style={{
                      padding: '10px 0',
                      borderBottom: i < stats.recent_security_events.length - 1 ? `1px solid ${isDark ? '#1f1f1f' : '#E2E8F0'}` : 'none',
                      display: 'flex', alignItems: 'flex-start', gap: '10px',
                    }}>
                      <div style={{
                        width: '28px', height: '28px', borderRadius: '50%',
                        background: isWarning ? (isDark ? '#1a1400' : '#FFFBEB') : (isDark ? '#1a0a0a' : '#FEF2F2'),
                        border: `1px solid ${isWarning ? (isDark ? '#B4530940' : '#FDE68A') : (isDark ? '#DC262640' : '#FECACA')}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '12px', flexShrink: 0,
                      }}>
                        {isWarning ? '⚠️' : '🛡️'}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '12px', fontWeight: 500, color: isDark ? '#e2e8f0' : '#0F172A' }}>
                          {event.description}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2px' }}>
                          <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#64748B' }}>
                            {event.user ? `User: ${event.user}` : 'System'}
                          </span>
                          {event.timestamp && (
                            <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#94A3B8' }}>
                              {new Date(event.timestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                            </span>
                          )}
                        </div>
                      </div>
                      <span style={{ fontSize: '10px', color: isDark ? '#94a3b8' : '#94A3B8', cursor: 'pointer', flexShrink: 0 }}>▾</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#94a3b8' : '#64748B', fontSize: '12px' }}>
                No security events
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        input[type="date"]::-webkit-calendar-picker-indicator { cursor: pointer; opacity: ${isDark ? '0.6' : '0.6'}; }
        select:focus, input:focus { outline: 2px solid ${isDark ? '#3B82F640' : '#BFDBFE'}; outline-offset: -1px; }
      `}</style>
    </div>
  );
}